export default __webpack_public_path__ + "img/QubNdZgT.675380ff.svg";